(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('.lnp-grid').forEach(root => {
      if (root.dataset.nextReady) return;
      root.dataset.nextReady = 'true';
      const mobile = matchMedia('(max-width: 800px)');
      const phases = [...root.querySelectorAll('[data-next-phase]')];
      const group = phases[0]?.getAttribute('name');
      const sync = () => {
        phases.forEach((phase, i) => {
          if (mobile.matches) phase.setAttribute('name', group);
          else phase.removeAttribute('name');
          phase.open = !mobile.matches || i === 0;
          phase.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
        });
      };
      sync(); mobile.addEventListener('change', sync);
    });
  };
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
